import React, { useMemo, useRef, useState } from 'react';
import { Tabs, Tab, Box, Dialog, DialogTitle, DialogContent, Typography, DialogActions } from '@mui/material';
import ContainerHeader from '../components/ContainerHeader';
import useSiteContract from './CustomHooks/useSiteContract';
import { ColumnDirective, ColumnsDirective, ContextMenu, GridComponent } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar, Filter, Group } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import ContractInfoDialog from './components/contractInfoDialog';
import EditContractTableData from './components/EditContractTableData';
import { useHistory } from 'react-router-dom';
import GeneratePDF from './components/GeneratePDF';
import NotificationModal from './components/ManageNotificationModal';
import MapView from './components/Map/MapView';
import RouteView from './components/Map/MapRoute';
import useMangeProduct from './CustomHooks/useManageproduct';
import ManageProductsModal from './components/ManageProductsModal';
import EditQuestionnaireModal from './components/EditQuestionnaireModal';
import AssignRelationModel from './components/AssignRelationModel';
import { dateTemplate } from '../GenTask/components/SharedFormFields';
import { useSendSageContractNotification } from './CustomHooks/useSendSageContractNotification';

class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}

const SiteContractPage = props => {
  const [activeTab, setActiveTab] = useState(0);
  const [openPDF, setOpenPDF] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [openPlantPassportModal, setOpenPlantPassportModal] = useState(false);

  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});

  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );

  const filterSettings = { type: 'Excel' };
  const toolbarOptions = ['Search'];
  const GeneratePDFRowDataRef = useRef(null);
  const ManageNotificationRowDataRef = useRef(null);

  const {
    siteContractsData,
    getSiteContractFullData,
    openContractInfoViewDialog,
    setOpenContractInfoViewDialog,
    contractInfoData,
    selectedContract,
    getFullSiteInfo,
    isSiteInfo,
    handleEditSaveContractSection,
    openEditContractInfoDialog,
    setOpenEditContractInfoDialog,
    selectedContractSection,
    handleOpenContractInfoEditModal,
    handleContractStatus,
    inactiveSiteContractData,
    saveSiteRef,
    updateFinishDate,
    updateStartDate,
    showMap,
    setShowMap,
    showRoute,
    setShowRoute,
    handleDeleteContract,
    openDeleteModal,
    setOpenDeleteModal,
    selectedContractId,
    setSelectedContractId,

    openAssignModal,
    setOpenAssignModal,
    assignParentContract,
    childContracts,
    loadingChildren,
    handleOpenAssignModal,
    handleSaveContractRelations,
    handleDeleteContractRelation,
    allRelations,
    handleSiteInfoClose,
  } = useSiteContract();

  const {
    openManageProductModal,
    setOpenManageProductModal,
    handleManageProductClick,
    products,
    handleDeleteProduct,
    openProductDeleteModal,
    setOpenProductDeleteModal,
    openProductModal,
    setOpenProductModal,
    modalMode,
    setModalMode,
    handleSave,
    dropDownValues,
  } = useMangeProduct();

  const { sendSageContractNotification } = useSendSageContractNotification();

  function siteInfoLinkTemplate(props) {
    const roleColor = props.roleLabel === 'Parent' ? '#2e7d32' : props.roleLabel === 'Child' ? '#1565c0' : 'blue';
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Button
          onClick={() => getSiteContractFullData({ ...props })}
          key={`${props.siteAssessmentID}_ref`}
          style={{ color: 'blue', fontWeight: 'bold', padding: '2px 4px', minWidth: 0 }}>
          {props.contractUniqueID}
        </Button>
        {props.roleLabel && (
          <span
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: roleColor,
              border: `1px solid ${roleColor}55`,
              borderRadius: 4,
              padding: '1px 5px',
              backgroundColor: `${roleColor}11`,
              whiteSpace: 'nowrap',
            }}>
            {props.roleLabel}
          </span>
        )}
      </div>
    );
  }

  function siteAssessmentDataShow(props) {
    return (
      <Button
        onClick={() => getFullSiteInfo({ ...props })}
        key={`${props.siteAssessmentID}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}>
        {props.siteAssessmentID}
      </Button>
    );
  }

  function PricingVersionTemplate(props) {
    const history = useHistory();
    const handleClick = () => {
      const { siteAssessmentID, pricingVersion } = props;
      const correctPricingVersion = pricingVersion.split(' ')[0];
      history.push(`/timberSalesPricing/${siteAssessmentID}/${correctPricingVersion}`);
    };
    return (
      <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={handleClick}>
        {props.pricingVersion}
      </span>
    );
  }

  function relationTemplate(props) {
    const label = props.relationLabel || '';
    if (!label) return <span style={{ fontSize: 12, color: '#bbb' }}>—</span>;
    return <span style={{ fontSize: 12, color: '#444', whiteSpace: 'normal', lineHeight: 1.5 }}>{label}</span>;
  }

  const contextMenuItems = [
    { text: 'Edit Questionnaire', target: '.e-rowcell', id: 'editQuestionnaire' },
    { text: 'Generate PDF', target: '.e-rowcell', id: 'GeneratePDF' },
    { text: 'Manage Notifications', target: '.e-rowcell', id: 'manageNotification' },
    { text: 'Plant Passport', target: '.e-rowcell', id: 'plantPassport' },
    { text: 'Assign Child Contracts', target: '.e-rowcell', id: 'assignChildContracts' },
    { text: 'Send Contract Notification', target: '.e-rowcell', id: 'sendContractNotification' },
    { text: 'Delete Contract', target: '.e-rowcell', id: 'deleteContract' },
    // { text: 'Manage Product - Destination', target: '.e-rowcell', id: 'editDeleteProducts' },
  ];

  const handleContextMenuClick = async args => {
    const rowData = args.rowInfo?.rowData;

    console.log(rowData, 'data');

    if (args.item.id === 'editQuestionnaire') {
      setEditData(rowData);
      setOpen(true);
    }
    if (args.item.id === 'GeneratePDF') {
      GeneratePDFRowDataRef.current = rowData;
      setOpenPDF(true);
    }
    if (args.item.id === 'manageNotification') {
      ManageNotificationRowDataRef.current = rowData;

      setOpenNotificationModal(true);
    }
    if (args.item.id === 'plantPassport') {
      setOpenPlantPassportModal(true);
    }

    if (args.item.id === 'assignChildContracts') {
      handleOpenAssignModal(rowData);
    }

    if (args.item.id === 'sendContractNotification') {
      await sendSageContractNotification(
        `Manually Notification for Contract - ${rowData.contractUniqueID}`,
        rowData.contractUniqueID,
        rowData,
      );
    }

    if (args.item.id === 'deleteContract') {
      // console.log(rowData.contractUniqueID, 'conData');
      setOpenDeleteModal(true);
      setSelectedContractId(rowData.contractUniqueID);
    }
    // if (args.item.id === 'editDeleteProducts') {
    //   handleManageProductClick(rowData.contractUniqueID);
    // }
  };

  const renderGrid = dataSource => (
    <DebugBoundary>
      <GridComponent
        contextMenuItems={contextMenuItems}
        contextMenuClick={handleContextMenuClick}
        dataSource={dataSource}
        filterSettings={filterSettings}
        allowPaging={true}
        pageSettings={pageSettings}
        allowSorting={true}
        allowTextWrap={true}
        allowResizing={true}
        allowMultiSorting={true}
        allowReordering={true}
        allowFiltering={true}
        height="100%"
        width="100%"
        toolbar={toolbarOptions}>
        <ColumnsDirective>
          <ColumnDirective
            field="contractUniqueID"
            headerText="Contract ID"
            width="120"
            textAlign="Left"
            template={siteInfoLinkTemplate}
            isPrimaryKey={true}
            clipMode="EllipsisWithTooltip"
          />
          <ColumnDirective
            field="relationLabel"
            headerText="Relation"
            width="150"
            textAlign="Left"
            template={relationTemplate}
            allowSorting={false}
            clipMode="EllipsisWithTooltip"
          />
          <ColumnDirective
            field="siteAssessmentID"
            headerText="Site Assess Ref"
            width="80"
            clipMode="EllipsisWithTooltip"
            template={siteAssessmentDataShow}
          />
          <ColumnDirective
            field="pricingVersion"
            headerText="Pricing Version"
            width="120"
            clipMode="EllipsisWithTooltip"
            template={PricingVersionTemplate}
          />
          <ColumnDirective field="wH_NumberName" headerText="Details" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="contractType" headerText="Contract Type" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="purchaseType" headerText="Purchase Type" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective
            field="submissionDate"
            headerText="Date"
            width="90"
            type="date"
            formatter={dateTemplate}
            clipMode="EllipsisWithTooltip"
          />
          <ColumnDirective field="county" headerText="County" width="80" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="supplier" headerText="Supplier Type" width="80" clipMode="EllipsisWithTooltip" />
          <ColumnDirective
            field="validSelfDeclaration"
            headerText="Valid Self Declaration"
            width="80"
            clipMode="EllipsisWithTooltip"
          />
          <ColumnDirective field="biomassSite" headerText="Biomass Site" width="70" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="forestGrower" headerText=" Forest Grower" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="customerName" headerText="Contract with" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="harvestedBy" headerText="Harvested By" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective
            field="tripartiteAgreement"
            headerText="Tripartite Agreement"
            width="70"
            clipMode="EllipsisWithTooltip"
          />
          <ColumnDirective field="notestoOffice" headerText="Notes" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="entrance" headerText="Entrance" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="forwardingRate" headerText="Forwarding Rate" width="70" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="harvestingRate" headerText="Harvesting Rate" width="70" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="contact1" headerText="Contact 1" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="contact2" headerText="Contact 2" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="contact3" headerText="Contact 3" width="100" clipMode="EllipsisWithTooltip" />
          <ColumnDirective field="reportsOnly" headerText="Report Only " width="60" clipMode="EllipsisWithTooltip" />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter, Group, Toolbar, ContextMenu]} />
      </GridComponent>
    </DebugBoundary>
  );

  return (
    <>
      <NotificationModal
        open={openNotificationModal}
        rowData={ManageNotificationRowDataRef}
        onClose={() => setOpenNotificationModal(false)}
      />

      <GeneratePDF openPDF={openPDF} rowData={GeneratePDFRowDataRef} onClose={() => setOpenPDF(false)} />

      <AssignRelationModel
        open={openAssignModal}
        onClose={() => setOpenAssignModal(false)}
        parentContract={assignParentContract}
        allContracts={siteContractsData}
        existingChildren={childContracts}
        loadingChildren={loadingChildren}
        onSave={handleSaveContractRelations}
        onDeleteChild={handleDeleteContractRelation}
        allRelations={allRelations}
      />

      <div className="app-wrapper siteWrapper">
        <ContainerHeader match={props.match} title={'Site Contracts'} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs value={activeTab} onChange={(e, newVal) => setActiveTab(newVal)}>
            <Tab label={`Active (${siteContractsData.length})`} sx={{ fontSize: '0.75rem' }} />
            <Tab label={`Inactive (${inactiveSiteContractData.length})`} sx={{ fontSize: '0.75rem' }} />
          </Tabs>
        </Box>

        {activeTab === 0 && (
          <div style={{ height: 'calc(100vh - 200px)', width: '100%' }}>{renderGrid(siteContractsData)}</div>
        )}

        {/* Inactive Tab */}
        {activeTab === 1 && (
          <div style={{ height: 'calc(100vh - 200px)', width: '100%' }}>{renderGrid(inactiveSiteContractData)}</div>
        )}

        {/* Dialogs */}
        <ContractInfoDialog
          handelSiteInfoEdit={isSiteInfo ? () => {} : handleOpenContractInfoEditModal}
          open={openContractInfoViewDialog}
          handleSiteInfoClose={handleSiteInfoClose}
          contractInfoData={contractInfoData}
          contractMainData={selectedContract}
          isSiteAssesmentData={isSiteInfo}
          handleContractStatus={handleContractStatus}
          saveSiteRef={saveSiteRef}
          updateFinishDate={updateFinishDate}
          updateStartDate={updateStartDate}
          setShowMap={setShowMap}
          setShowRoute={setShowRoute}
        />

        {selectedContract?.siteAssessmentID && (
          <MapView open={showMap} setOpen={setShowMap} siteAssessmentID={selectedContract?.siteAssessmentID} />
        )}

        {selectedContract?.siteAssessmentID && (
          <RouteView open={showRoute} setOpen={setShowRoute} siteAssessmentID={selectedContract?.siteAssessmentID} />
        )}

        <EditContractTableData
          open={openEditContractInfoDialog}
          setOpen={setOpenEditContractInfoDialog}
          sectionData={selectedContractSection.sectionData}
          sectionName={selectedContractSection.sectionName}
          handleEditSave={handleEditSaveContractSection}
        />

        <ManageProductsModal
          open={openManageProductModal}
          setOpen={setOpenManageProductModal}
          products={products}
          handleDeleteProduct={handleDeleteProduct}
          openDeleteModal={openProductDeleteModal}
          setOpenDeleteModal={setOpenProductDeleteModal}
          openProductModal={openProductModal}
          setOpenProductModal={setOpenProductModal}
          modalMode={modalMode}
          setModalMode={setModalMode}
          handleSave={handleSave}
          dropDownValues={dropDownValues}
        />

        <EditQuestionnaireModal open={open} setOpen={setOpen} data={editData} />

        <Dialog
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: { borderRadius: 3, p: 1 },
          }}>
          <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>Delete Metadata</DialogTitle>

          <DialogContent sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: '15px' }}>
              Are you sure you want to this Contract
              <strong style={{ marginLeft: 4, fontWeight: 'bold' }}>{selectedContractId || null}</strong>
            </Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => setOpenDeleteModal(false)} sx={{ textTransform: 'none' }}>
              Cancel
            </Button>

            <Button
              variant="contained"
              style={{ backgroundColor: '#FF2400', color: '#fff' }}
              onClick={() => handleDeleteContract(selectedContractId || null)}
              sx={{ textTransform: 'none' }}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default SiteContractPage;
